<template>
  <div class="f-tag" @click="$emit('click')">
    <slot></slot>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,500;0,700;1,300&display=swap");

.f-tag {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;

  background-color: var(--white-a10);
  border-radius: 24px;

  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--white-a75);

  border: 1px solid;

  border-color: transparent;

  cursor: pointer;

  &:hover {
    border: 1px solid var(--white-a25);

  }

  &:active {
    border: 1px solid var(--white-a50);
  }
}
</style>